export default __webpack_public_path__ + "static/CustomerPic3-f78b839268575859dc18a395aa827ef5.png";